import React from "react";
import ThreadTable from "../../../features/ai/llm-rag/components/table/ThreadTable";

function ThreadsPage({}) {
    return <ThreadTable />;
}

export default ThreadsPage;
